<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid style="margin-top: 5%;">
		<b-row class="mt-3 mb-2">
				<b-col >
					<h3>At Timex: {{attime}}</h3>
				</b-col>
				
			</b-row>
		</b-container>
		<b-container fluid class="pb-4">		
				<div class="panel-record mt-4 mb-4">
					
					<b-tabs content-class="mt-3" align="center" active-nav-item-class="font-weight-bold text-danger">
						<!-- ============================ CCMS ON Start ========================== -->
						
						<b-tab :title="'CCMS ON ('+filteredrecords.length+')'" active>

							<b-row class="mt-3 mb-2">							
								<b-col class="col-md-6 col-sm-6 col-xs-6 text-right "  offset-md="6">
									<b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF(filteredrecords,'ccms_on')">Download PDF</b-button>
									<b-button variant="dark" pill size="sm"  @click="downloadcsv(filteredrecords,'ccms_on')">Download CSV</b-button>					
								</b-col>
							</b-row>
							<b-row class="">
								<b-col lg="6">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									<span class="ml-2">entries</span>
								</b-col>
								
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="left" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search" class="custom-input">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="pt-3">
								<b-col lg="12">
									
									<b-table show-empty  sticky-header="true" responsive outlined  caption-top  hover head-variant="dark" borderless="borderless" id="my-table-live" stickyColumn="scrolled" stacked="md" :items="filteredrecords" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" class="d-flex">
										
										
										<template v-slot:head(feeder_pillar_no)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Feeder Piller No.'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(phase)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Installation Phase'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(no_of_fittings)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Number of Lights.'" >{{ data.label}}           
											</span>           
										</template>

										<template v-slot:head(meter_phase_type)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Phase Type'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(modem_type)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Modem type'" >{{ data.label}}           
											</span>           
										</template> 
										<template v-slot:head(overload)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Over Load'" >{{ data.label}}           
											</span>           
										</template> 

										

										

										<!-- <template v-slot:head(ulb)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Urban Local Body'" >{{ data.label}}           
											</span>           
										</template> -->

										<template v-slot:cell(location)="row">
											<span :id="'l-'+row.item.id" pill variant="success">{{row.value}}</span>
											<b-popover
												:target="`l-${row.item.id}`"
												title="Location"
												triggers="hover focus">
												{{row.item.location}}													
											</b-popover>
										</template>
										<template v-slot:cell(ward_id)="row">
											<span :id="'wl-'+row.item.id" pill variant="success" v-if="row.value!=0">{{row.value.areacode}}</span>
											<span v-else pill variant="success" >No Ward</span>
											<b-popover
												:target="`wl-${row.item.id}`"
												title="Location"
												triggers="hover focus">
												{{row.value.title}}													
											</b-popover>
										</template>
										
										<template v-slot:cell(no_of_fittings)="row">
											<b-badge :id="'F-'+row.item.id" pill variant="success">{{row.item.no_of_fittings}}</b-badge>
											<!-- <b-popover
												:target="`F-${row.item.id}`"
												title="Total Fittings!"
												triggers="hover focus">
												<div v-for="value in watts" v-bind:key="value">
													<b-row v-if="row.item.led_fittings['w'+value] > 0">
														<b-col><b-badge pill variant="light" class="pb-1">{{value}} w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.led_fittings['w'+value]}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{value * row.item.led_fittings['w'+value]}} w</b-badge></b-col>
													</b-row>
												</div>													
											</b-popover> -->
										</template>
										<template v-slot:cell(geo_loc)="row">
											<span>{{row.item.location_lat}}</span><br><span>{{row.item.location_lng}}</span>
										</template>
										<template v-slot:cell(maintenance)="row">
											<b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
											<b-badge pill variant="secondary" v-else>NO</b-badge>
										</template>
										<template v-slot:cell(door_status)="row">
											<b-badge pill size="sm" variant="danger" v-if="row.value == 1">OPENED</b-badge>
											<b-badge pill size="sm" variant="success" v-else>CLOSED</b-badge>
										</template>
										<!-- <template v-slot:cell(mcb_status)="row">

											<b-list-group style="flex-direction:row;">
												<b-list-group-item class="d-flex align-items-center m-0 p-0 border-0">
													<span :class="row.item.r_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> R
												</b-list-group-item>

												<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
													
													<span :class="row.item.y_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> Y
												</b-list-group-item>

												<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
													<span :class="row.item.b_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> B
												</b-list-group-item>
											</b-list-group>
											
										</template> -->
										<template v-slot:cell(overload)="row">
											<b-badge pill variant="danger" v-if="(row.value > 0)">{{row.value}} %</b-badge>
											<b-badge pill variant="danger" v-else> 0 %</b-badge>
											<!--<b-badge pill variant="warning" v-else-if="(row.item.output_status == 1 && row.value == 0 )">{{row.value}} %</b-badge>-->
											<!--<b-badge pill variant="success" v-else>{{row.value}} %</b-badge>-->
										</template>
										<template v-slot:cell(underload)="row">
											<b-badge pill variant="primary" v-if="(row.value > 0)">{{row.value}} %</b-badge>
										</template>
										<template v-slot:cell(supply)="row">
											<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
											<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
										</template>
										<template v-slot:cell(output_status)="row">
											<b-badge pill variant="success" v-if="(row.value == 1)">ON</b-badge>
											<b-badge pill variant="danger" v-else>OFF</b-badge>
										</template>
										<template v-slot:cell(sys_meter_no)="row">
											<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
											<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
										</template>
										<template v-slot:cell(meter_phase_type)="row">
											<!-- v-if="row.value == 3" -->
											<div  style="display:flex; flex-direction:column; row-gap:2px;">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_r == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_y == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_b == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
											</div>
											<!-- <div v-if="row.value == 1" style="display:flex; flex-direction:column; row-gap:2px;">
												<img src="../assets/meter-ok.svg" v-if="row.item.amp_r > 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else-if="row.item.amp_y > 0" style="max-width:14px; max-height:14px;" class="py-0">
												<img src="../assets/meter-ok.svg" v-else-if="row.item.amp_b > 0" style="max-width:14px; max-height:14px;" class="py-0">
												<img src="../assets/meter-error.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
											</div> -->
										</template>
										<!-- <template v-slot:cell(mode)="row">
											<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
											<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
										</template> -->
										<template v-slot:cell(feeder_pillar_no)="row">
											<b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
										</template>
										<template v-slot:cell(ploe_no_start)="row">
											<p>{{row.item.ploe_no_start+' - '+row.item.ploe_no_end}}</p>
										</template>
										<template v-slot:cell(connection_status)="row">
											<span>{{row.item.last_event}}</span>
											<b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">METER FAULT</b-badge></div></b-link>
											<b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
											<b-badge pill variant="warning" v-else-if="row.value == 3">DATA FAULT</b-badge>
											<b-badge pill variant="success" v-else>CONNECTED</b-badge>
										</template>
										<template v-slot:cell(actions)="row">
											<a href="#" @click="sendCommand('ON', row.item.imei_no)">On btn</a>										
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-1">
								<b-col lg="6">
									<span class="mr-2">Showing {{currentPage}} to {{(perPage>filteredrecords.length)?filteredrecords.length:perPage}} of {{filteredrecords.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
									<b-pagination v-model="currentPage" pills :total-rows="filteredrecords.length" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</b-tab>
						<!-- ============================ CCMS ON END ========================== -->
						<!-- ============================ CCMS OFF Start ======================= -->
						<b-tab :title="'CCMS OFF ('+fault_ccms_off.length+')'" >
							<b-row class="mt-3 mb-2">							
								<b-col class="col-md-6 col-sm-6 col-xs-6 text-right "  offset-md="6">
									<b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF(fault_ccms_off,'fault_ccms_off')">Download PDF</b-button>
									<b-button variant="dark" pill size="sm"  @click="downloadcsv(fault_ccms_off,'fault_ccms_off')">Download CSV</b-button>					
								</b-col>
							</b-row>
							
							<b-row class="">
								<b-col lg="6">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage_ccms_off" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									<span class="ml-2">entries</span>
								</b-col>
								
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="left" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter_ccms_off" type="search" id="filterInput" placeholder="Type to Search" class="custom-input">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter_ccms_off" @click="filter_ccms_off = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="pt-3">
								<b-col lg="12">

									<b-table show-empty  sticky-header="true" responsive outlined  caption-top  hover head-variant="dark" borderless="borderless" id="my-table-live" stickyColumn="scrolled" stacked="md" :items="fault_ccms_off" :fields="fields" :current-page="currentPage" :per-page="perPage_ccms_off" :filter="filter_ccms_off" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFilteredCcmsOff" class="d-flex">
										<template v-slot:head(feeder_pillar_no)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Feeder Piller No.'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(phase)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Installation Phase'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(no_of_fittings)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Number of Lights.'" >{{ data.label}}           
											</span>           
										</template>

										<template v-slot:head(meter_phase_type)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Phase Type'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(modem_type)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Modem type'" >{{ data.label}}           
											</span>           
										</template> 
										<template v-slot:head(overload)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Over Load'" >{{ data.label}}           
											</span>           
										</template> 

										

										

										<!-- <template v-slot:head(ulb)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Urban Local Body'" >{{ data.label}}           
											</span>           
										</template> -->

										<template v-slot:cell(location)="row">
											<span :id="'l-'+row.item.id" pill variant="success">{{row.value}}</span>
											<b-popover
												:target="`l-${row.item.id}`"
												title="Location"
												triggers="hover focus">
												{{row.item.location}}													
											</b-popover>
										</template>
										<template v-slot:cell(ward_id)="row">
											<span :id="'wl-'+row.item.id" pill variant="success" v-if="row.value!=0">{{row.value.areacode}}</span>
											<span v-else pill variant="success" >No Ward</span>
											<b-popover
												:target="`wl-${row.item.id}`"
												title="Location"
												triggers="hover focus">
												{{row.value.title}}													
											</b-popover>
										</template>
										
										<template v-slot:cell(no_of_fittings)="row">
											<b-badge :id="'F-'+row.item.id" pill variant="success">{{row.item.no_of_fittings}}</b-badge>
											<!-- <b-popover
												:target="`F-${row.item.id}`"
												title="Total Fittings!"
												triggers="hover focus">
												<div v-for="value in watts" v-bind:key="value">
													<b-row v-if="row.item.led_fittings['w'+value] > 0">
														<b-col><b-badge pill variant="light" class="pb-1">{{value}} w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.led_fittings['w'+value]}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{value * row.item.led_fittings['w'+value]}} w</b-badge></b-col>
													</b-row>
												</div>													
											</b-popover> -->
										</template>
										<template v-slot:cell(geo_loc)="row">
											<span>{{row.item.location_lat}}</span><br><span>{{row.item.location_lng}}</span>
										</template>
										<template v-slot:cell(maintenance)="row">
											<b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
											<b-badge pill variant="secondary" v-else>NO</b-badge>
										</template>
										<template v-slot:cell(door_status)="row">
											<b-badge pill size="sm" variant="danger" v-if="row.value == 1">OPENED</b-badge>
											<b-badge pill size="sm" variant="success" v-else>CLOSED</b-badge>
										</template>
										<!-- <template v-slot:cell(mcb_status)="row">

											<b-list-group style="flex-direction:row;">
												<b-list-group-item class="d-flex align-items-center m-0 p-0 border-0">
													<span :class="row.item.r_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> R
												</b-list-group-item>

												<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
													
													<span :class="row.item.y_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> Y
												</b-list-group-item>

												<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
													<span :class="row.item.b_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> B
												</b-list-group-item>
											</b-list-group>
											
										</template> -->
										<template v-slot:cell(overload)="row">
											<b-badge pill variant="danger" v-if="(row.value > 0)">{{row.value}} %</b-badge>
											<b-badge pill variant="danger" v-else> 0 %</b-badge>
											<!--<b-badge pill variant="warning" v-else-if="(row.item.output_status == 1 && row.value == 0 )">{{row.value}} %</b-badge>-->
											<!--<b-badge pill variant="success" v-else>{{row.value}} %</b-badge>-->
										</template>
										<template v-slot:cell(underload)="row">
											<b-badge pill variant="primary" v-if="(row.value > 0)">{{row.value}} %</b-badge>
										</template>
										<template v-slot:cell(supply)="row">
											<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
											<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
										</template>
										<template v-slot:cell(output_status)="row">
											<b-badge pill variant="success" v-if="(row.value == 1)">ON</b-badge>
											<b-badge pill variant="danger" v-else>OFF</b-badge>
										</template>
										<template v-slot:cell(sys_meter_no)="row">
											<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
											<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
										</template>
										<template v-slot:cell(meter_phase_type)="row">
											<!-- v-if="row.value == 3" -->
											<div  style="display:flex; flex-direction:column; row-gap:2px;">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_r == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_y == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_b == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
											</div>
											<!-- <div v-if="row.value == 1" style="display:flex; flex-direction:column; row-gap:2px;">
												<img src="../assets/meter-ok.svg" v-if="row.item.amp_r > 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else-if="row.item.amp_y > 0" style="max-width:14px; max-height:14px;" class="py-0">
												<img src="../assets/meter-ok.svg" v-else-if="row.item.amp_b > 0" style="max-width:14px; max-height:14px;" class="py-0">
												<img src="../assets/meter-error.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
											</div> -->
										</template>
										<!-- <template v-slot:cell(mode)="row">
											<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
											<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
										</template> -->
										<template v-slot:cell(feeder_pillar_no)="row">
											<b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
										</template>
										<template v-slot:cell(ploe_no_start)="row">
											<p>{{row.item.ploe_no_start+' - '+row.item.ploe_no_end}}</p>
										</template>
										<template v-slot:cell(connection_status)="row">
											<span>{{row.item.last_event}}</span>
											<b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">METER FAULT</b-badge></div></b-link>
											<b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
											<b-badge pill variant="warning" v-else-if="row.value == 3">DATA FAULT</b-badge>
											<b-badge pill variant="success" v-else>CONNECTED</b-badge>
										</template>
										<template v-slot:cell(actions)="row">
											<a href="#" @click="sendCommand('ON', row.item.imei_no)">On btn</a>										
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-1">
								<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage_ccms_off>fault_ccms_off.length)?fault_ccms_off.length:perPage_ccms_off}} of {{fault_ccms_off.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows_ccms_off" :per-page="perPage_ccms_off" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</b-tab>
						<!-- ============================CCMS OFF END ========================== -->
						<!-- ============================ CCMS Signal Loss Start ======================= -->
						<b-tab :title="'CCMS  Signal Loss ('+fault_signal_loss.length+')'" >
							<b-row class="mt-3 mb-2">							
								<b-col class="col-md-6 col-sm-6 col-xs-6 text-right "  offset-md="6">
									<b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF(fault_signal_loss,'filter_signal_loss')">Download PDF</b-button>
									<b-button variant="dark" pill size="sm"  @click="downloadcsv(fault_signal_loss,'filter_signal_loss')">Download CSV</b-button>					
								</b-col>fault_signal_loss
							</b-row>
							<b-row class="">
								<b-col lg="6">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage_signal_loss" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									<span class="ml-2">entries</span>
								</b-col>
								
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="left" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter_signal_loss" type="search" id="filterInput" placeholder="Type to Search" class="custom-input">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter_signal_loss" @click="filter_signal_loss = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="pt-3">
								<b-col lg="12">

									<b-table show-empty  sticky-header="true" responsive outlined  caption-top  hover head-variant="dark" borderless="borderless" id="my-table-live" stickyColumn="scrolled" stacked="md" :items="fault_signal_loss" :fields="fields" :current-page="currentPage" :per-page="perPage_signal_loss" :filter="filter_signal_loss" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered_signal_loss" class="d-flex">
										<template v-slot:head(feeder_pillar_no)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Feeder Piller No.'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(phase)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Installation Phase'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(no_of_fittings)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Number of Lights.'" >{{ data.label}}           
											</span>           
										</template>

										<template v-slot:head(meter_phase_type)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Phase Type'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(modem_type)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Modem type'" >{{ data.label}}           
											</span>           
										</template> 
										<template v-slot:head(overload)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Over Load'" >{{ data.label}}           
											</span>           
										</template> 

										

										

										<!-- <template v-slot:head(ulb)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Urban Local Body'" >{{ data.label}}           
											</span>           
										</template> -->

										<template v-slot:cell(location)="row">
											<span :id="'l-'+row.item.id" pill variant="success">{{row.value}}</span>
											<b-popover
												:target="`l-${row.item.id}`"
												title="Location"
												triggers="hover focus">
												{{row.item.location}}													
											</b-popover>
										</template>
										<template v-slot:cell(ward_id)="row">
											<span :id="'wl-'+row.item.id" pill variant="success" v-if="row.value!=0">{{row.value.areacode}}</span>
											<span v-else pill variant="success" >No Ward</span>
											<b-popover
												:target="`wl-${row.item.id}`"
												title="Location"
												triggers="hover focus">
												{{row.value.title}}													
											</b-popover>
										</template>
										
										<template v-slot:cell(no_of_fittings)="row">
											<b-badge :id="'F-'+row.item.id" pill variant="success">{{row.item.no_of_fittings}}</b-badge>
											<!-- <b-popover
												:target="`F-${row.item.id}`"
												title="Total Fittings!"
												triggers="hover focus">
												<div v-for="value in watts" v-bind:key="value">
													<b-row v-if="row.item.led_fittings['w'+value] > 0">
														<b-col><b-badge pill variant="light" class="pb-1">{{value}} w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.led_fittings['w'+value]}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{value * row.item.led_fittings['w'+value]}} w</b-badge></b-col>
													</b-row>
												</div>													
											</b-popover> -->
										</template>
										<template v-slot:cell(geo_loc)="row">
											<span>{{row.item.location_lat}}</span><br><span>{{row.item.location_lng}}</span>
										</template>
										<template v-slot:cell(maintenance)="row">
											<b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
											<b-badge pill variant="secondary" v-else>NO</b-badge>
										</template>
										<template v-slot:cell(door_status)="row">
											<b-badge pill size="sm" variant="danger" v-if="row.value == 1">OPENED</b-badge>
											<b-badge pill size="sm" variant="success" v-else>CLOSED</b-badge>
										</template>
										<!-- <template v-slot:cell(mcb_status)="row">

											<b-list-group style="flex-direction:row;">
												<b-list-group-item class="d-flex align-items-center m-0 p-0 border-0">
													<span :class="row.item.r_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> R
												</b-list-group-item>

												<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
													
													<span :class="row.item.y_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> Y
												</b-list-group-item>

												<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
													<span :class="row.item.b_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> B
												</b-list-group-item>
											</b-list-group>
											
										</template> -->
										<template v-slot:cell(overload)="row">
											<b-badge pill variant="danger" v-if="(row.value > 0)">{{row.value}} %</b-badge>
											<b-badge pill variant="danger" v-else> 0 %</b-badge>
											<!--<b-badge pill variant="warning" v-else-if="(row.item.output_status == 1 && row.value == 0 )">{{row.value}} %</b-badge>-->
											<!--<b-badge pill variant="success" v-else>{{row.value}} %</b-badge>-->
										</template>
										<template v-slot:cell(underload)="row">
											<b-badge pill variant="primary" v-if="(row.value > 0)">{{row.value}} %</b-badge>
										</template>
										<template v-slot:cell(supply)="row">
											<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
											<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
										</template>
										<template v-slot:cell(output_status)="row">
											<b-badge pill variant="success" v-if="(row.value == 1)">ON</b-badge>
											<b-badge pill variant="danger" v-else>OFF</b-badge>
										</template>
										<template v-slot:cell(sys_meter_no)="row">
											<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
											<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
										</template>
										<template v-slot:cell(meter_phase_type)="row">
											<!-- v-if="row.value == 3" -->
											<div  style="display:flex; flex-direction:column; row-gap:2px;">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_r == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_y == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_b == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
											</div>
											<!-- <div v-if="row.value == 1" style="display:flex; flex-direction:column; row-gap:2px;">
												<img src="../assets/meter-ok.svg" v-if="row.item.amp_r > 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else-if="row.item.amp_y > 0" style="max-width:14px; max-height:14px;" class="py-0">
												<img src="../assets/meter-ok.svg" v-else-if="row.item.amp_b > 0" style="max-width:14px; max-height:14px;" class="py-0">
												<img src="../assets/meter-error.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
											</div> -->
										</template>
										<!-- <template v-slot:cell(mode)="row">
											<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
											<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
										</template> -->
										<template v-slot:cell(feeder_pillar_no)="row">
											<b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
										</template>
										<template v-slot:cell(ploe_no_start)="row">
											<p>{{row.item.ploe_no_start+' - '+row.item.ploe_no_end}}</p>
										</template>
										<template v-slot:cell(connection_status)="row">
											<span>{{row.item.last_event}}</span>
											<b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">METER FAULT</b-badge></div></b-link>
											<b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
											<b-badge pill variant="warning" v-else-if="row.value == 3">DATA FAULT</b-badge>
											<b-badge pill variant="success" v-else>CONNECTED</b-badge>
										</template>
										<template v-slot:cell(actions)="row">
											<a href="#" @click="sendCommand('ON', row.item.imei_no)">On btn</a>										
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-1">
								<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage_signal_loss>fault_signal_loss.length)?fault_signal_loss.length:perPage_signal_loss}} of {{fault_signal_loss.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows_signal_loss" :per-page="perPage_signal_loss" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</b-tab>
						<!-- =========================== CCMS Signal Loss END ========================== -->
						<!-- ============================ CCMS Power Cut Start ======================= -->
						<b-tab :title="'CCMS  Power Cut ('+fault_power_cut.length+')'" v-if="$root.chkperm('page_devices','light_fault_list')">
							<b-row class="mt-3 mb-2">							
								<b-col class="col-md-6 col-sm-6 col-xs-6 text-right "  offset-md="6">
									<b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF(fault_power_cut,'fault_power_cut')">Download PDF</b-button>
									<b-button variant="dark" pill size="sm"  @click="downloadcsv(fault_power_cut,'fault_power_cut')">Download CSV</b-button>					
								</b-col>
							</b-row>
							<b-row class="">
								<b-col lg="6">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage_power_cut" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									<span class="ml-2">entries</span>
								</b-col>
								
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="left" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter_power_cut" type="search" id="filterInput" placeholder="Type to Search" class="custom-input">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter_power_cut" @click="filter_power_cut = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="pt-3">
								<b-col lg="12">

									<b-table show-empty  sticky-header="true" responsive outlined  caption-top  hover head-variant="dark" borderless="borderless" id="my-table-live" stickyColumn="scrolled" stacked="md" :items="fault_power_cut" :fields="fields" :current-page="currentPage" :per-page="perPage_power_cut" :filter="filter_power_cut" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered_power_cut" class="d-flex">
										<template v-slot:head(feeder_pillar_no)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Feeder Piller No.'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(phase)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Installation Phase'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(no_of_fittings)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Number of Lights.'" >{{ data.label}}           
											</span>           
										</template>

										<template v-slot:head(meter_phase_type)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Phase Type'" >{{ data.label}}           
											</span>           
										</template>
										<template v-slot:head(modem_type)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Modem type'" >{{ data.label}}           
											</span>           
										</template> 
										<template v-slot:head(overload)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Over Load'" >{{ data.label}}           
											</span>           
										</template> 

										

										

										<!-- <template v-slot:head(ulb)="data">                     
											<span :title='data.tooltip' v-b-popover.hover.top="'Urban Local Body'" >{{ data.label}}           
											</span>           
										</template> -->

										<template v-slot:cell(location)="row">
											<span :id="'l-'+row.item.id" pill variant="success">{{row.value}}</span>
											<b-popover
												:target="`l-${row.item.id}`"
												title="Location"
												triggers="hover focus">
												{{row.item.location}}													
											</b-popover>
										</template>
										<template v-slot:cell(ward_id)="row">
											<span :id="'wl-'+row.item.id" pill variant="success" v-if="row.value!=0">{{row.value.areacode}}</span>
											<span v-else pill variant="success" >No Ward</span>
											<b-popover
												:target="`wl-${row.item.id}`"
												title="Location"
												triggers="hover focus">
												{{row.value.title}}													
											</b-popover>
										</template>
										
										<template v-slot:cell(no_of_fittings)="row">
											<b-badge :id="'F-'+row.item.id" pill variant="success">{{row.item.no_of_fittings}}</b-badge>
											<!-- <b-popover
												:target="`F-${row.item.id}`"
												title="Total Fittings!"
												triggers="hover focus">
												<div v-for="value in watts" v-bind:key="value">
													<b-row v-if="row.item.led_fittings['w'+value] > 0">
														<b-col><b-badge pill variant="light" class="pb-1">{{value}} w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.led_fittings['w'+value]}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{value * row.item.led_fittings['w'+value]}} w</b-badge></b-col>
													</b-row>
												</div>													
											</b-popover> -->
										</template>
										<template v-slot:cell(geo_loc)="row">
											<span>{{row.item.location_lat}}</span><br><span>{{row.item.location_lng}}</span>
										</template>
										<template v-slot:cell(maintenance)="row">
											<b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
											<b-badge pill variant="secondary" v-else>NO</b-badge>
										</template>
										<template v-slot:cell(door_status)="row">
											<b-badge pill size="sm" variant="danger" v-if="row.value == 1">OPENED</b-badge>
											<b-badge pill size="sm" variant="success" v-else>CLOSED</b-badge>
										</template>
										<!-- <template v-slot:cell(mcb_status)="row">

											<b-list-group style="flex-direction:row;">
												<b-list-group-item class="d-flex align-items-center m-0 p-0 border-0">
													<span :class="row.item.r_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> R
												</b-list-group-item>

												<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
													
													<span :class="row.item.y_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> Y
												</b-list-group-item>

												<b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">
													<span :class="row.item.b_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> B
												</b-list-group-item>
											</b-list-group>
											
										</template> -->
										<template v-slot:cell(overload)="row">
											<b-badge pill variant="danger" v-if="(row.value > 0)">{{row.value}} %</b-badge>
											<b-badge pill variant="danger" v-else> 0 %</b-badge>
											<!--<b-badge pill variant="warning" v-else-if="(row.item.output_status == 1 && row.value == 0 )">{{row.value}} %</b-badge>-->
											<!--<b-badge pill variant="success" v-else>{{row.value}} %</b-badge>-->
										</template>
										<template v-slot:cell(underload)="row">
											<b-badge pill variant="primary" v-if="(row.value > 0)">{{row.value}} %</b-badge>
										</template>
										<template v-slot:cell(supply)="row">
											<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
											<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
										</template>
										<template v-slot:cell(output_status)="row">
											<b-badge pill variant="success" v-if="(row.value == 1)">ON</b-badge>
											<b-badge pill variant="danger" v-else>OFF</b-badge>
										</template>
										<template v-slot:cell(sys_meter_no)="row">
											<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
											<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
										</template>
										<template v-slot:cell(meter_phase_type)="row">
											<!-- v-if="row.value == 3" -->
											<div  style="display:flex; flex-direction:column; row-gap:2px;">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_r == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_y == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
												<img src="../assets/meter-error.svg" v-if="row.item.amp_b == 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
											</div>
											<!-- <div v-if="row.value == 1" style="display:flex; flex-direction:column; row-gap:2px;">
												<img src="../assets/meter-ok.svg" v-if="row.item.amp_r > 0" style="max-width:14px; max-height:14px;" >
												<img src="../assets/meter-ok.svg" v-else-if="row.item.amp_y > 0" style="max-width:14px; max-height:14px;" class="py-0">
												<img src="../assets/meter-ok.svg" v-else-if="row.item.amp_b > 0" style="max-width:14px; max-height:14px;" class="py-0">
												<img src="../assets/meter-error.svg" v-else style="max-width:14px; max-height:14px;" class="my-0">
											</div> -->
										</template>
										<!-- <template v-slot:cell(mode)="row">
											<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
											<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
										</template> -->
										<template v-slot:cell(feeder_pillar_no)="row">
											<b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
										</template>
										<template v-slot:cell(ploe_no_start)="row">
											<p>{{row.item.ploe_no_start+' - '+row.item.ploe_no_end}}</p>
										</template>
										<template v-slot:cell(connection_status)="row">
											<span>{{row.item.last_event}}</span>
											<b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">METER FAULT</b-badge></div></b-link>
											<b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
											<b-badge pill variant="warning" v-else-if="row.value == 3">DATA FAULT</b-badge>
											<b-badge pill variant="success" v-else>CONNECTED</b-badge>
										</template>
										<template v-slot:cell(actions)="row">
											<a href="#" @click="sendCommand('ON', row.item.imei_no)">On btn</a>										
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-1">
								<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage_power_cut>fault_power_cut.length)?fault_power_cut.length:perPage_power_cut}} of {{fault_power_cut.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows_power_cut" :per-page="perPage_power_cut" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</b-tab>
						<!-- ============================ CCMS Power Cut End ======================= -->
					</b-tabs>
					<b-row>
						<b-col>
							
						</b-col>
					</b-row>

				
					
					<!-- <b-row class="my-3">
						<b-col> 
							<div class="float-left">
								<img src="../assets/flag-green.png" style="width: 20px; max-height:28px;"/>
								<span class="pl-2 text-sm"><b>DEVICE ON</b></span>
							</div>
							<div class="float-left ml-5">
								<img src="../assets/flag-red.png" style="width: 20px; max-height:28px;"/>
								<span class="pl-2 text-sm"><b>DEVICE OFF</b></span>
							</div>
							<div class="float-left ml-5">
								<img src="../assets/flag-blue.png" style="width: 20px; max-height:28px;"/>
								<span class="pl-2 text-sm"><b>TEMPORARY SIGNAL LOSS</b></span>
							</div>
						</b-col>
						<b-col cols="6">
							<span class="float-right text-sm pt-2"><b>LAST SYNC TIME: {{$moment(last_sync_time).format('DD-MM-YYYY HH:mm')}}</b></span>
							
						</b-col>
					</b-row> -->
				
					

						
				
						
				</div>			

			</b-container>
		
	</div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'dashboardreportdetails',
	components: {
		"top-header": Header
	},
	mounted(){
		this.loadulbs();
		this.loadzones();
		this.loadwards();
		this.initload();
		
	},
	data() {
		var self = this; 
		return{
			email: '',
			password: '',
			selectedUlb: 'Jhansi-Smart-City',
			ulbsUrl: self.$session.get('apiurl')+'aligarhapi/zone-list',
			zonesUrl: self.$session.get('apiurl')+'aligarhapi/zones',
			wardsUrl: self.$session.get('apiurl')+'aligarhapi/ward-record',
			url: self.$session.get('apiurl')+'aligarhapi/dashboard-reports-detail',
			recordUrl: self.$session.get('apiurl')+'aligarhapi/device-ulbs',
			deviceId: self.$route.params.deviceId,
			location: '',
			records: [],
			device: {},
			led_fittings: {},
			attime:'',
total_devices: 0,
zones: [],
wards: [],
filteredrecords: [],
//records: [],
totalRows: 1,
totalRows_ccms_off:1,
totalRows_signal_loss:1,
totalRows_power_cut:1,
currentPage: 1,
selectedfilter: 'CONNECT',
pageOptions: [10, 20, 50, 100, 500, 1000, 2000],
perPage: 10,
perPage_ccms_off: 10,
perPage_signal_loss:10,
perPage_power_cut:10,
sortBy: '',
sortDesc: false,
sortDirection: 'asc',
filter: null,
filter_ccms_off: null,
filter_signal_loss:null,
filter_power_cut:null,
filterOn: [],
/* ********fields ********** */
fields: [	
	{ key: 'feeder_pillar_no', label: 'F.No.', sortable: true,   class: 'text-center',thStyle:'min-width:85px;' },
	{ key: 'imei_no', label: 'IMEI', sortable: true,  sortDirection: 'desc' },
	{ key: 'location', label: 'Location',  sortable: true,  class: 'text-left',thStyle:'min-width:140px;',
	formatter: (value) => { 
	if(value != null){
		if(value.length > 15){
			return value.substring(0,15)+"...";
		}		
	}
	return value;
	},
	},
	{ key: 'ward_id', label: 'Ward', sortable: true,  sortDirection: 'desc' ,thStyle:'min-width:90px;',
		formatter: (value) => {
			if(value > 0){
				return self.wards.filter(function (item) {
					return item.id == value;
				})[0];
			}
			else{
				return 0;
			}
		},
	},	
	/* { key: 'phase', label: 'PH', sortable: true,  sortDirection: 'desc' }, */
	{ key: 'no_of_fittings', label: 'Fittings', sortable: false,	sortByFormatted: true, filterByFormatted: true },
	{ key: 'total_load', label: 'Physical Load (KW)', sortable: true,  class: 'text-center',thStyle:'min-width:130px;',
		formatter: (value) => { 
		return (value/1000).toFixed(3);
		},
	},
	{ key: 'total_kw', label: 'Actual Load (KW)', class: 'text-center', sortable: true, sortDirection: 'desc',thStyle:'min-width:130px;',
		formatter: (value, key, item) => { 
			if(item.meter_type === '1P'){
				//return (item.kw_r/10000).toFixed(3);
			}
			if(item.output_status == 0){
				//value = 0;
			}
			return parseFloat(value).toFixed(3);
		},
	},
	{ key: 'supply', label: 'Power',sortable: true,   class:"text-center", 
		formatter: (value, key, item) => {
		var supply = 'ON';
		if(item.datalength == 59){
			supply = 'OFF';
		}
		if(item.modem_type == '2G' && item.supply < 75){
			supply = 'OFF';
		}
		if(item.modem_type == '4G' && item.supply < 120){
			supply = 'OFF';
		}
		return supply;
		},
	},
	{ key: 'door_status', label: 'Door Status', sortable: true,class:"text-center",thStyle:'min-width:115px;'  },
	/* { key: 'mcb_status', label: 'MCB Status', 'extra': 1 }, */
	/* { key: 'modem_type', label: 'MT',  sortable: true,  sortDirection: 'desc' }, 
	{ key: 'geo_loc', label: 'GEO Location',thStyle:'min-width:115px;'},
	{ key: 'sys_meter_no', label: 'MS', sortable: true,  
	formatter: (value, key, item) => {
	if(value == item.device_no){
		return 0;
	}
	return 1;
	},
	}, */
	{ key: 'output_status', label: 'Output' , 
		formatter: (value) => {	
		return value;
		},
	},
	{ key: 'overload', label: 'OL',sortable: true,  class: 'text-right',
		formatter: (value, key, item) => {
			var fault = 0;
			if(item.meter_type === '1P'){
				//fault = 100*((item.kw_r/10000) - (item.total_load/1000))/(item.total_load/1000) ;
				fault = 100*((item.kw_r) - (item.total_load))/(item.total_load) ;
			}else{
				//fault = 100*((item.total_kw/100000) - (item.total_load/1000))/(item.total_load/1000);
				fault = 100*((item.total_kw) - (item.total_load/1000))/(item.total_load/1000);
			}
			//console.log('item:'+item.imei_no+'------'+item.total_load);
			fault = 100*((item.total_kw) - (item.total_load/1000))/(item.total_load/1000);
			return fault.toFixed(1);		
		},
	},	
	/* { key: 'mode', label: 'Mode',sortable: true, class: 'text-center' }, */	
	
	],
	/* ********CCMS OFF  ********** */
	fault_ccms_off:[],	
	fault_signal_loss:[],	
	fault_power_cut:[],	
			
	};
	},
	methods: {
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key'),
				deviceId: self.deviceId
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records 				 = response.data.result.records;
					var deviceData 				 = JSON.parse(self.records.device_data);
					var device_on_imei 			 = deviceData.device_on_imei;
					var device_off_imei 		 = deviceData.device_off_imei;
					var device_signal_loss_imei	 = deviceData.device_signal_loss_imei;
					var total_power_cut_imei	 = deviceData.total_power_cut_imei; 
					self.attime					 = self.$moment(self.records.update_time).format('DD-MM-YYYY HH:mm');
					/* console.log(device_on_imei+'============');
					console.log(device_off_imei+'============');
					console.log(device_signal_loss_imei+'============');
					console.log(total_power_cut_imei+'============');  */
					// Ccms ON
					device_on_imei.forEach(function(item){
						self.filteredrecords.push(JSON.parse(item));
					});	
					self.totalRows = self.filteredrecords.length;

					// Ccms Off				
					device_off_imei.forEach(function(item){
						self.fault_ccms_off.push(JSON.parse(item));
					});	
					self.totalRows_ccms_off = self.fault_ccms_off.length;


					// Ccms Signal Loss	
					device_signal_loss_imei.forEach(function(item){
						self.fault_signal_loss.push(JSON.parse(item));
					});	
					self.totalRows_signal_loss = self.fault_signal_loss.length;

					// Ccms Signal Loss	
					total_power_cut_imei.forEach(function(item){
						self.fault_power_cut.push(JSON.parse(item));
					});	
					self.totalRows_power_cut = self.fault_power_cut.length;


					

					
					
					//.location = response.data.result.location;
					//self.loading = false;
					//self.totalRows = self.records.length;
					//self.device = response.data.result.device;
					
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		loadzones(){
			var self = this;
			
			self.axios.post(self.zonesUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zones = response.data.result;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		loadulbs(){
			var self = this;
			
			self.axios.post(self.ulbsUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zoneOptions = response.data.result;
					self.zoneOptions.forEach(function(field){
						//if(field.state == 'in-mh'){
							if(field.areacode == self.selectedUlb){
								self.zoneOptions.forEach(function(field2){
									if(field2.id == field.parent){
										self.page_title = field.title;
										return;
									}
								});
							}
						//}
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		loadwards(){
			var self = this;
			
			self.axios.post(self.wardsUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.wards = response.data.result;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		onFilteredCcmsOff(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows_ccms_off = filteredItems.length;
			this.currentPage = 1
		},
		onFiltered_signal_loss(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows_signal_loss = filteredItems.length;
			this.currentPage = 1
		},	
		onFiltered_power_cut(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows_power_cut = filteredItems.length;
			this.currentPage = 1
		},		
		downloadcsv(datalist,reportType){
			console.log('asdasdadas=='+datalist.length);
			var self = this;
			var reportTitle = '';
			var downloadName = '';
			if(reportType=='ccms_on'){
				reportTitle ='CCMSOn';
				downloadName = 'ccms_on';
			}else if(reportType=='fault_ccms_off'){
				reportTitle ='CCMS OFF';
				downloadName = 'ccms_off';
			}else if(reportType=='filter_signal_loss'){
				reportTitle ='CCMS Signal Loss';
				downloadName = 'ccms_signal_loss';
			}else if(reportType=='fault_power_cut'){
				reportTitle ='CCMS Power Cut';
				downloadName = 'ccms_power_cut';
			}else{
				reportTitle = '';
				downloadName = '';
			}
			var d = new Date();
			var uniq = downloadName+'-'+d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();
			console.log(reportTitle+'--'+downloadName);
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			datalist.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
						if(field.key != 'extra'){
							var fieldData = row[field.key];
							//console.log('field.keyfield.key'+field.key);
							/* if(field.key =='light_data'){
								var value = row[field.key];
								var threadValue =0;
								if(value!=null && value!='null'){
									var lightData = JSON.parse(value);							
									threadValue =  lightData.thread; 
								}
								fieldData=threadValue;
							} */
							if(field.key == 'location'){
								if(fieldData!='' && fieldData!=null){
								fieldData=fieldData.replace(","," ");
								}
							}
							if(field.key == 'output_status'){
								if(fieldData ==1){
									fieldData = "ON";
								}else{
									fieldData = "OFF";
								}
							}
						

							if(field.key == 'door_status'){
								if(fieldData ==1){
									fieldData = "OPEN";
								}else{
									fieldData = "CLOSED";
								}
							}
							
							if(field.key == 'supply'){
								
								if(fieldData < 120){
									fieldData = "Off";
								}else{
									fieldData = 'On';
								}
							}
							

							if(field.key == 'total_load'){
								fieldData = (fieldData/1000).toFixed(3);
							}

							if(field.key == 'overload'){
								//fieldData = (fieldData/1000).toFixed(3);
								fieldData = '0%';
								if(row.total_kw>(row.total_load/1000)){
									console.log(row.total_kw+'----'+row.total_load)
									var fault = 100*((row.total_kw) - (row.total_load/1000))/(row.total_load/1000);
									fieldData =  fault.toFixed(1)+'%';
								}
							}

							if(field.key == 'ward_id'){
								//console.log('ward_id:'+fieldData);
								if(fieldData!=''){
										var wardname =  self.wards.filter(function (item) {
											return item.id == fieldData;
										})[0].title;

										fieldData =wardname.replace(","," ");
									}else{
										fieldData ='No Ward';	
									}
							}
							dataarr.push(fieldData);
						}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "REPORT_"+uniq+".csv");
			
			document.body.appendChild(link); // Required for FF

			link.click();
		},
		downloadPDF(datalist,reportType){
			var self = this; 
			var reportTitle = '';
			var downloadName = '';
			if(reportType=='ccms_on'){
				reportTitle ='CCMSOn';
				downloadName = 'ccms_on';
			}else if(reportType=='fault_ccms_off'){
				reportTitle ='CCMS OFF';
				downloadName = 'ccms_off';
			}else if(reportType=='filter_signal_loss'){
				reportTitle ='CCMS Signal Loss';
				downloadName = 'ccms_signal_loss';
			}else if(reportType=='fault_power_cut'){
				reportTitle ='CCMS Power Cut';
				downloadName = 'ccms_power_cut';
			}else{
				reportTitle = '';
				downloadName = '';
			}
			var d = new Date();
			var uniq = downloadName+'-'+d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();
			console.log(reportTitle+'--'+downloadName);

			var pdfMake = require('pdfmake/build/pdfmake.js');
			var pdfFonts = require('pdfmake/build/vfs_fonts.js');
			pdfMake.vfs = pdfFonts.pdfMake.vfs;

			var pdfdata = new Array();
			var data = new Array();
			self.fields.forEach(element => {
				data.push(element.label);
			});
			pdfdata.push(data); 
			for(var i=0; i<datalist.length; i++){
				data = new Array();
				
				self.fields.forEach(element => {
					var value = datalist[i][element.key];
					var row = datalist[i];

					/* =============================  */
					if(element.key == 'location'){
					
						if(value!='' && value!=null){
						value=value.replace(","," ");
						}
					}
					if(element.key == 'output_status'){
						if(value ==1){
							value = "ON";
						}else{
							value = "OFF";
						}
					}


					if(element.key == 'door_status'){
						if(value ==1){
							value = "OPEN";
						}else{
							value = "CLOSED";
						}
					}

					if(element.key == 'supply'){
						
						if(value < 120){
							value = "Off";
						}else{
							value = 'On';
						}
					}

					if(element.key == 'total_load'){
						value = (value/1000).toFixed(3);
					}

					if(element.key == 'overload'){
					
						value = '0%';
						if(row.total_kw>(row.total_load/1000)){
							console.log(row.total_kw+'----'+row.total_load)
							var fault = 100*((row.total_kw) - (row.total_load/1000))/(row.total_load/1000);
							value =  fault.toFixed(1)+'%';
						}

						
					} 

					if(element.key == 'ward_id'){
						if(value!=''){
							var wardname =  self.wards.filter(function (item) {
								return item.id == value;
							})[0].title;

							value =wardname.replace(","," ");
						}else{
							value ='No Ward';	
						}
						
						
					}
					/* *********************************** */



					data.push(value);
				});
				pdfdata.push(data);
			}
			//var deviceid = self.imeino;
			

			//var d = new Date();
		//	var uniq = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();
			var docDefinition = {
				content: [
					{ text: reportTitle+' Report : '+self.attime, style: 'heading' },
                   	{
						layout: 'lightHorizontalLines',
						table: {
							headerRows: 1,

							body: pdfdata
						}
					}
				],
				styles: {
					heading: {
						fontSize: 20,
						alignment: 'center',
						lineHeight: 1,
						bold: true,
						
					},
                    subheading: {
                        fontSize: 14,
						alignment: 'center',
						lineHeight: 2,
						bold: false
                    }
				},
				defaultStyle: {
					fontSize: 10,
					bold: false
				},
				pageOrientation: 'landscape',
			};
			pdfMake.createPdf(docDefinition).download("REPORT_"+uniq+".pdf");
		},
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table td, .table th{
	vertical-align: middle;
}


#my-table-live .thead-dark th {
    color: #fff;
	background-color: #FF9A37;
    border-color: #FF9A37;
}
#my-table-live .first-col {
   border-radius: 20px 0px 0px 0px;
   min-width: 130px;
}
#my-table-live .last-cal {
   border-radius: 0px 20px 0px 0px;
   min-width: 153px;
}
.borderRadius20{
	border-radius: 20px;
}
.table-responsive{
	border-radius: 20px;
}

.info-box img {
    display: inline-table;    
    margin: 0px;
}
</style>